import { IState } from 'legacy/lut/store'

export const selectPartnerData = (state: IState) => state.partner.partnerData
